import * as yup from "yup";
import { alphaNumericPattern, emailrgx } from "../assets/constant";
export const schema = (t) => yup.object({
        title: yup
          .string()
          .trim()
          .matches(alphaNumericPattern, t("Please enter a valid title"))
          .required(t("Please enter employer title")),
        name: yup
          .string()
          .trim()
          .matches(alphaNumericPattern, t("Please enter a valid name"))
          .required(t("Please enter employer name")),
        phone: yup
          .string().trim().matches(/^\+\d{1,4}\d{6,14}$/, t("Please enter a valid international phone number that starts with +"))
          .required(t("Contact number is required")),
        email: yup
          .string()
          .trim(),
    });